export default "__VITE_ASSET__Cdle0CW0__"